import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApplicationInsights, trackMetric } from './telemetry/appInsights';

initializeApplicationInsights();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals(metric => {
  trackMetric(`web-vitals.${metric.name}`, metric.value, {
    id: metric.id,
    rating: 'rating' in metric ? String(metric.rating) : '',
  });
});
